import React, { useCallback } from 'react';
import { ProductGridCard } from 'src/components/product-card-new';
import { Product } from '../../../types';

export const ProductCardWrapper = ({
  product,
  lazyLoadImage = false,
  onClick,
}: {
  product: Product;
  lazyLoadImage?: boolean;
  onClick?: (p: Product) => void;
}) => {
  const onClickHandler = useCallback(() => {
    if (typeof onClick === 'function') {
      onClick(product);
    }
  }, [product, onClick]);
  return (
    <ProductGridCard
      link={product.pathName}
      name={product.name}
      price={product.priceSummary?.regular}
      rating={product.userReviewSummary?.rating}
      reviewCount={product.userReviewSummary?.count}
      onClick={onClickHandler}
      brand={product.brand}
      imageSrc={product.media.first}
      shouldLazyLoadImage={lazyLoadImage}
      rank={product.popularity?.inCategory}
      properties={product.properties?.nodes}
    />
  );
};
